












import { defineComponent, ref } from '@nuxtjs/composition-api'
import InputFile from './InputFile.vue'
import { defineProps } from '@/helpers/defineProps'
import { FormInputType } from '@/contracts/FormInputType'
import { FormMask } from '@/contracts/FormMask'
type InputFileProps = {
  id: string
  accept: string
  type: FormInputType
  label: string
  placeholder: string
  currentValue: string
  mask: FormMask
  withBorder: boolean
  error: boolean | string
  rules: string[]
  tooltip: string
  tooltipSrc: string
  value: any
}
export default defineComponent({
  name: 'InputFileMultiple',
  components: { InputFile },
  props: defineProps<InputFileProps>({
    id: { default: '' },
    accept: { default: '' },
    type: { default: FormInputType.Text },
    label: { default: '' },
    placeholder: { default: '' },
    currentValue: { default: '' },
    mask: { default: FormMask.NotSet },
    withBorder: { default: false },
    error: { default: false },
    rules: { default: () => [] as string[] },
    tooltip: { default: '' },
    tooltipSrc: { default: 'images/tooltipDoc.png' },
    value: { default: null },
  }),
  setup(props, ctx) {
    const files = ref<any>(props.value || [])
    const inputProps = (file: any) => {
      const indexOf = files.value.findIndex((v) => v.id === file.id)
      if (file.name) {
        return {
          ...props,
          label: indexOf === 0 ? props.label : '',
          value: file,
        }
      }

      return {
        ...props,
        label: files.value.length ? '' : props.label,
        value: null,
      }
    }
    const onInput = (val: any, id: any) => {
      if (val) {
        val.id = id

        files.value.push(val)
        ctx.emit('input-change', files.value)
        ctx.emit('input', files.value)
      } else {
        const indexOf = files.value.findIndex((v) => v.id === id)
        if (indexOf === -1) {
          return
        }

        files.value.splice(indexOf, 1)
        ctx.emit('input-change', files.value)
        ctx.emit('input', files.value)
      }
      if (!files.value.length) {
        ctx.emit('input-change', null)
        ctx.emit('input', null)
      }
    }
    return {
      files,
      props,
      onInput,
      inputProps,
    }
  },
})
